import AOS from 'aos';

$(function () {
    //mobile nav controller
    $('.mobile-nav-trigger, .blog-mobile-nav-trigger').on('click', function () {
        $(this).toggleClass('active');
        $('nav.nav').toggleClass('mobile-menu-open');
        $('header.header').toggleClass('open');
        $('.logo-img').toggleClass('d-none');
        $('.mobile-logo-img').toggleClass('d-none');
        $('body').toggleClass('overflow-hidden');
    });

    $('.blog-mobile-nav-trigger').on('click', function () {
        $('#mobile-menu-open').toggleClass('active');
        $('#mobile-menu-close').toggleClass('active');
    });

    $(window).resize(function() {
        closeMobileMenuOnDesktopResize();
    })

    createJumpLinks();

    $( '.jump-links-nav-container-header' ).click( function() {
        $( 'i.open-jump-link-menu' ).toggleClass('jump-link-menu-toggled');
        $( 'i.close-jump-link-menu' ).toggleClass('jump-link-menu-toggled');
        $( '.jump-links-container' ).toggleClass('open');
    });

    /*********** Teamwork: these two functions work together *********
     The first function triggers the second function, but the
     second function must also work independently
     */
    $( '.clear-search' ).click( function() {
        // Give input focus on "clearing", which triggers second function:
        $( '.search-results-page-input' ).focus();
    });

    $( '.search-results-page-input' ).focus( function() {
        // On search input focus, remove placeholder and clear value
        $(this).attr('placeholder', '').val('');
    });
    /****************************************************************/

    $( '#blog-search-open' ).click(function() {
        let searchOpen = $( ".search-open" ).length; // .search-open class detected
        if( searchOpen ) {
            $( '#blog-search-container' ).removeClass('search-open');
            $( '#blog-search-open' ).removeClass('search-open');
        } else {
            $( '#blog-search-container' ).addClass('search-open');
            $( '#blog-search-open' ).addClass('search-open');
        }

    })

    fixContentPlacement();

    // wait for Blog Article Featured Image to load, then adjust content placement if needed
    $( '.blog-article-featured-image' ).one("load", function() {
        fixContentPlacement();
    })

    // adjust content based on screen size:
    $( window ).resize(function () {
        fixContentPlacement();
    });

    //search btn
    $('.search-btn-trigger').on('click', function () {
        $('.search-container').slideToggle(250);
        $('header.header').toggleClass('search-open');
        $('.search-container input').focus();
    });

    //accordion logic
    $('.a-header').on('click', function () {
        //if user clicked on an open accordion
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).next().slideUp();
            $(this).find('i').removeClass('fa-minus').addClass('fa-plus');
        }
        //user clicked on closed accordion
        else {
            //setup some vars to make life easy peezy
            var $thisH = $(this);
            var $thisB = $(this).next();
            var $thisI = $(this).find('i');

            //close all open accords
            $('.single-accordion .a-body').slideUp();
            $('.single-accordion .a-header').removeClass('open');
            $('.single-accordion .a-header i').removeClass('fa-minus').addClass('fa-plus');

            //open the clicked accord
            $thisB.slideDown();
            $thisH.addClass('open');
            $thisI.removeClass('fa-plus').addClass('fa-minus');
        }
    });
    //open the first accordion on load
    $('.a-header').eq(0).trigger('click');

    //spam prevention technique
    //submits the form if fake-input is empty
    $('.form-with-fi').on('submit', function () {
        if ($('[name="fi"]').val().length != 0) {
            return !1
        }
    })


    //parsley custom validators for free account password
    window.Parsley.addValidator('uppercase', {
        requirementType: 'number',
        validateString: function (value, requirement) {
            var uppercases = value.match(/[A-Z]/g) || [];
            return uppercases.length >= requirement;
        },
        messages: {
            en: 'Your password must contain at least %s uppercase letter.'
        }
    });
    window.Parsley.addValidator('lowercase', {
        requirementType: 'number',
        validateString: function (value, requirement) {
            var lowercases = value.match(/[a-z]/g) || [];
            return lowercases.length >= requirement;
        },
        messages: {
            en: 'Your password must contain at least %s lowercase letter.'
        }
    });
    window.Parsley.addValidator('number', {
        requirementType: 'number',
        validateString: function (value, requirement) {
            var numbers = value.match(/[0-9]/g) || [];
            return numbers.length >= requirement;
        },
        messages: {
            en: 'Your password must contain at least %s number.'
        }
    });
    window.Parsley.addValidator('special', {
        requirementType: 'number',
        validateString: function (value, requirement) {
            var specials = value.match(/[^a-zA-Z0-9]/g) || [];
            return specials.length >= requirement;
        },
        messages: {
            en: 'Your password must contain at least %s special character.'
        }
    });

    AOS.init();
});

function createJumpLinks() {
    let i = 0;
    if( $(".jump-links-container").length > 0 ) {
        $("h2").each(function() {
            let jump_link_id = "blog-jump-link-" + i;
            let jump_link_text = $( this ).text();

            $(this).attr('id', jump_link_id);
            $(this).addClass('blog-jump-link');

            $('.jump-links-container').append(
                "<a href='#" + jump_link_id + "'>" + jump_link_text + "</a>"
            );
            i++;
        });
    }
}

/**
 * Adjusts the bottom-margin of the blog article image container based on the image height
 */
function fixContentPlacement() {
    const breakpointLarge = 991;
    const breakpointMedium = 768;

    let currentWindowWidth = $(window).width();

    if (currentWindowWidth > breakpointLarge) {
        let neededMargin = $('.blog-article-featured-image').outerHeight() - $('.blog-article-header').outerHeight() + 120;

        $('.blog-article-header').css('margin-bottom', neededMargin);
    }

    // Adjusts the mobile search button text on smaller screens
    if( currentWindowWidth > breakpointMedium ) {
        $('#body-searchsubmit').val('Search');
    }
    else {
        $('#body-searchsubmit').val('');
    }
}

function closeMobileMenuOnDesktopResize() {
    if (window.matchMedia("(min-width:1100px)").matches) {
        // close the mobile menu
        $('nav.nav').removeClass('mobile-menu-open');
        // display the proper mobile menu icon
        $('#mobile-menu-open').addClass('active');
        $('#mobile-menu-close').removeClass('active');
        // display the proper logo
        $('.logo-img').removeClass('d-none');
        $('.mobile-logo-img').addClass('d-none');
    }
}
